"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var rxjs_1 = require("rxjs"),
    InteractionResponse_1 = require("../model/InteractionResponse");

exports.InteractionEvent = {
  Changed: "changed",
  Complete: "complete",
  Started: "started"
};

var Interaction = function () {
  function e() {
    this.subject = new rxjs_1.Subject();
  }

  return e.prototype.complete = function () {
    var t = this;
    clearTimeout(this.timeoutHandler), this.timeoutHandler = setTimeout(function () {
      var e = new InteractionResponse_1.InteractionResponse(exports.InteractionEvent.Complete, 0);
      t.subject.next(e);
    }, 100);
  }, e.prototype.started = function () {
    var e = new InteractionResponse_1.InteractionResponse(exports.InteractionEvent.Started, 1);
    this.subject.next(e);
  }, e.prototype.changed = function (e) {
    var t = new InteractionResponse_1.InteractionResponse(exports.InteractionEvent.Changed, e);
    this.subject.next(t);
  }, e;
}();

exports.Interaction = Interaction;